query ListSubscriptions($eventId: ID) {
  subscriptions: StreamToolsListSubscriptions(eventId: $eventId) {
    subscriptionId
    channelLogin
    broadcasterUserId
    botUserId
    type
    kind
    status
    createdAt
    revocationReason
    revokedAt
  }
}
